function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.065 21s-1.747 1.388-2.336 2.254c-.59.866-1.133 2.842-1.133 2.842l20.578 9.427c.53 1.9 2.937 4.42 5.83 4.42 1.031 0 2-.322 2.846-.82l-.319.469L51.501 50s1.467-.98 2.056-1.846c.59-.866.855-2.435.855-2.435l-20.656-9.987c.113-.329.19-.647.19-.931 0-1.902-2.66-3.446-5.942-3.446-.896 0-1.737.124-2.5.33z",
  strokeLinecap: "square",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.904 21s1.747 1.388 2.336 2.254c.59.866 1.133 2.842 1.133 2.842l-20.578 9.427c-.53 1.9-2.937 4.42-5.83 4.42-1.032 0-2-.322-2.846-.82l.318.469L4.468 50s-1.467-.98-2.056-1.846c-.59-.866-.856-2.435-.856-2.435l20.656-9.987c-.112-.329-.19-.647-.19-.931 0-1.902 2.66-3.446 5.942-3.446.897 0 1.738.124 2.5.33z",
  strokeLinecap: "square",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.984 31s1.454-1.454 4-1.454 4 1.454 4 1.454"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.984 5.5s.627-.5 1-.5 1 .5 1 .5v24h-2z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M29 6c1.763-.405 3-1.954 3-2.45C32 2.97 30.21 2 28 2s-4 .97-4 1.55c0 .475 1.203 1.981 2.854 2.45",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}));

var SvgCeilingfan = function SvgCeilingfan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCeilingfan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ceiling fan.bfbf168e.svg";
export { ForwardRef as ReactComponent };